<template>
  <v-app id="app">
    <div v-if="$tStore.isMaintenance" class="maintenance-hint-text">
      <div>メンテナンス中</div>
    </div>
    <v-main :style="backgroundThemeStyle">
      <router-view />
      <FullScreenLoading :isLoading="$tStore.isLoading" :opacity="$tStore.opacity" />
    </v-main>
  </v-app>
</template>
<script lang="ts" src="./App.ts" />
<style lang="scss" src="./App.scss" />
